// Distinguishes which discoverability surface drove a user toward Continuous Matter Drive Sync —
// either pre-connection discovery (Settings, before any DMS is linked) or the post-connection
// setup flow (connecting an account / picking a folder) — so adoption can be attributed back to
// the entry point instead of being indistinguishable from a direct visit to Matter Settings.
export enum MatterDriveSyncEntrySource {
  MatterCreation = 'matter_creation',
  MatterSettings = 'matter_settings',
  FileActionMenu = 'file_action_menu',
  AddTemplateButton = 'add_template_button',
  MedSummaryCreate = 'med_summary_create',
  MatterAssetAddFiles = 'matter_asset_add_files',
  MatterOverview = 'matter_overview',
  // Matter Files (drive) page — the same setup banner the Matter Overview shows, on the files surface.
  DriveView = 'drive_view',
  // Sidebar Sync Files card — pre-connection discovery with no matter context (`matterId` omitted).
  Sidebar = 'sidebar',
}

// Distinguishes how a user left the folder picker without completing a folder map, for picker
// friction analysis (cancel button vs. backdrop/escape dismissal).
export enum MatterDriveSyncDismissReason {
  Cancel = 'cancel',
  Backdrop = 'backdrop',
}
